import styled from 'styled-components'

export type ContainerProps = {
  bgColor: string
}

export const Container = styled.div<ContainerProps>`
  display: inline-block;
  padding: 3rem 5rem;
  background-color: ${({ bgColor }) =>
    bgColor ? bgColor : 'var(--gold-color)'};
  transition: all 0.3s ease;

  &:hover {
    filter: brightness(85%);
  }

  p {
    color: var(--shape-color) !important;
    letter-spacing: 2px;
  }
`

